interface NumberRange {
  start: number;
  end: number;
  step: number;
}

export const numberRange = ({ start, end, step }: NumberRange) =>
  /* eslint-disable no-mixed-operators */
  Array.from({ length: (end - start) / step + 1 }, (_, i) => start + i * step);
